import Marquee from "react-fast-marquee";
import { Play } from "lucide-react";

const REEL = [
  "/images/finish-line-2025.png",
  "/images/volunteers-2025.png",
  "/images/josiah-runner.jpg",
  "/images/candid-runners.jpg",
  "/images/youth-runner-2.jpg",
  "/images/adult-runners.jpg",
  "/images/youth-house-of-purpose.jpg",
  "/images/ebony-tonja.jpg",
];

export default function LiveReel() {
  return (
    <section data-testid="section-reel" className="relative bg-[#0A0A0A] py-14 md:py-20 border-t border-[#27272A] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-6 md:mb-8 flex items-end justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-2 border border-[#EC008C]/60 bg-[#EC008C]/10 px-3 py-1 mb-3">
            <span className="w-2 h-2 rounded-full bg-[#EC008C] animate-pulse" />
            <span className="text-[10px] uppercase tracking-[0.28em] text-[#EC008C] font-bold">Live Reel</span>
          </div>
          <h3 className="font-display text-2xl md:text-4xl font-black uppercase tracking-tight text-white">
            The movement in motion.
          </h3>
        </div>
        <div className="hidden md:flex items-center gap-2 text-xs uppercase tracking-widest text-[#A3A3A3]">
          <Play className="w-4 h-4 text-[#00A651] fill-[#00A651]" /> Auto-playing highlights
        </div>
      </div>

      <Marquee gradient={false} speed={40} pauseOnHover>
        {REEL.map((url, i) => (
          <div key={i} className="mx-2 relative w-64 md:w-80 h-40 md:h-52 border border-[#27272A] overflow-hidden shrink-0 group">
            <img src={url} alt="" loading="lazy" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        ))}
      </Marquee>
      <Marquee gradient={false} speed={30} direction="right" className="mt-3">
        {REEL.slice().reverse().map((url, i) => (
          <div key={i} className="mx-2 relative w-48 md:w-64 h-32 md:h-40 border border-[#27272A] overflow-hidden shrink-0 group">
            <img src={url} alt="" loading="lazy" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
